import { StorageService } from "src/app/core/helpers/storage.service";
import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";


export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: "root",
})
export class ClearStorageGuard
   {
  constructor(private storageService: StorageService) {}
  canDeactivate() {
    this.storageService.removeAll();
    return true;
  }
}
